import {Component, ElementRef, HostListener, inject, Input} from "@angular/core";

/**
 * This component allows to drag the carousel with the mouse.
 */
@Component({
    standalone: true,
    selector: '[appDraggableCarousel]',
    templateUrl: './draggable-carousel.component.html',
    styleUrls: ['./draggable-carousel.component.scss'],
    host: {
        'class': 'draggable-carousel'
    }
})
export class DraggableCarouselComponent {

    /**
     * Whether the carousel is draggable or not.
     */
    @Input() isDraggable: boolean = true;

    private isDragging: boolean = false;

    private prevPageX = 0;

    private prevScrollLeft = 0;

    //The host element is the carousel.
    private carousel = inject(ElementRef)

    @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        this.dragStart(event);
    }

    @HostListener('mousemove', ['$event']) onMouseMove(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        this.dragging(event);
    }

    /**
     * Handles both the mouseup and mouseleave events.
     * @param event - The mouse event triggering this handler.
     */
    @HostListener('mouseup', ['$event'])
    @HostListener('mouseleave', ['$event'])
    onMouseExit(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        this.dragStop(event);
    }

    @HostListener('click', ['$event']) onClick(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        //Avoids clicking on the element when dragging it.
        event.stopPropagation();
        event.preventDefault();
    }

    private dragStart(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        //Only drag with left button of the mouse.
        if (event.buttons !== 1) {
            return;
        }
        this.isDragging = true;
        this.prevPageX = event.pageX;
        this.prevScrollLeft = this.carousel.nativeElement.scrollLeft;
    }

    private dragging(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        if (!this.isDragging) {
            return;
        }
        this.carousel.nativeElement.classList.add('dragging');
        event.preventDefault();
        const positionDiff = event.pageX - this.prevPageX;
        this.carousel.nativeElement.scrollLeft = this.prevScrollLeft - positionDiff
    }

    private dragStop(event: MouseEvent) {
        if (!this.isDraggable) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        this.carousel.nativeElement.classList.remove('dragging');
    }

}
